var map = {
  "./mobile/index.js": [
    "80519",
    9,
    "9598",
    "87603",
    "26391",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "45603",
    "72206"
  ],
  "./desktop/index.js": [
    "9403",
    9,
    "9598",
    "76225",
    "62815",
    "87603",
    "73980",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "45603",
    "92570"
  ],
  "./desktop/index": [
    "9403",
    9,
    "9598",
    "76225",
    "62815",
    "87603",
    "73980",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "45603",
    "92570"
  ],
  "./mobile": [
    "80519",
    9,
    "9598",
    "87603",
    "26391",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "45603",
    "72206"
  ],
  "./desktop": [
    "9403",
    9,
    "9598",
    "76225",
    "62815",
    "87603",
    "73980",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "45603",
    "92570"
  ],
  "./desktop/": [
    "9403",
    9,
    "9598",
    "76225",
    "62815",
    "87603",
    "73980",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "45603",
    "92570"
  ],
  "./common/VocListing": [
    "36654",
    9,
    "9598",
    "87603",
    "45603",
    "474"
  ],
  "./VocListing.scss": [
    "22996",
    7,
    "77261"
  ],
  "./mobile/": [
    "80519",
    9,
    "9598",
    "87603",
    "26391",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "45603",
    "72206"
  ],
  "./mobile/index": [
    "80519",
    9,
    "9598",
    "87603",
    "26391",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "45603",
    "72206"
  ],
  "./common/VocListing.js": [
    "36654",
    9,
    "9598",
    "87603",
    "45603",
    "474"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 13453;
module.exports = __rspack_async_context;
